// pkce localstorage keys
export const SITE_NAME = 'pkceSiteName';
export const STATE = 'pkceState';
export const CODE_VERIFIER = 'pkceCodeVerifier';

// others
export const ROUTE = 'pageRoute';
export const ONE_HOUR = 1000 * 60 * 60;
